/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TopBudgetByTenantRequest extends models.CommonCostRequest {
    getFixupPrototypeFunction() { return TopBudgetByTenantRequest.fixupPrototype; }

    static newInstance(model: Partial<TopBudgetByTenantRequest>): TopBudgetByTenantRequest {
        let obj = Object.assign(new TopBudgetByTenantRequest(), model);
        TopBudgetByTenantRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TopBudgetByTenantRequest>): TopBudgetByTenantRequest {
        if (!model) return null;
        return TopBudgetByTenantRequest.newInstance(<TopBudgetByTenantRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TopBudgetByTenantRequest) {
        if (!obj) return;

        models.TopBudgetByTenantRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TopBudgetByTenantRequest): boolean {
        if (models.CommonCostRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TopBudgetByTenantRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
